import logEvent from '../logEvent';

function logEventDigitalAccess(code, data) {
  logEvent(`ACTVN-${code}`, data);
}

export function logEventTriage1(data) {
  logEventDigitalAccess('01', data);
}

export function logEventTriage2(data) {
  logEventDigitalAccess('02', data);
}

export function logEventExistingEmbarkCustomer() {
  logEventDigitalAccess('03');
}

export function logEventWelcome() {
  logEventDigitalAccess('04');
}

export function logEventDigitalAccessIdvStart() {
  logEventDigitalAccess('07');
}

export function logEventDigitalAccessIdvSuccess(verificationJob) {
  const { id } = verificationJob || {};
  logEventDigitalAccess('08', { jobId: id });
}

export function logEventDigitalAccessPersonalInfo(data) {
  logEventDigitalAccess('09', data);
}

export function logEventDigitalAccessSIN() {
  logEventDigitalAccess('10');
}

export function logEventDigitalAccessCallUs() {
  logEventDigitalAccess('11');
}

export function logEventDigitalAccessEmploymentStatus(data) {
  logEventDigitalAccess('12', data);
}

export function logEventDigitalAccessMaritalStatus(data) {
  logEventDigitalAccess('13', data);
}

export function logEventDigitalAccessAnnualIncome(data) {
  logEventDigitalAccess('14', data);
}

export function logEventDigitalAccessAssetsLiabilities(data) {
  logEventDigitalAccess('15', data);
}

export function logEventDigitalAccessNumDependents(data) {
  logEventDigitalAccess('16', data);
}

export function logEventDigitalAccessInvExperience(data) {
  logEventDigitalAccess('17', data);
}

export function logEventDigitalAccessSuccess() {
  logEventDigitalAccess('18');
}

export function logEventDigitalAccessGoToHomepage() {
  logEventDigitalAccess('19');
}

export function logEventDigitalAccessCannotContinue() {
  logEventDigitalAccess('20');
}

export function logEventDigitalAccessEnstreamStart() {
  logEventDigitalAccess('25');
}

export function logEventDigitalAccessEnstreamPass() {
  logEventDigitalAccess('26');
}

export function logEventDigitalAccessEnstreamFail(data) {
  logEventDigitalAccess('27', data);
}
